import { tsr } from '../../lib/api.js';

/**
 * "Today" as the employee's own location sees it (CLAUDE.md invariant 3) — the attendance status
 * endpoint resolves `date` in `location.timezone` server-side. The browser clock is never used to
 * decide what day it is; until this loads, callers get `undefined` and render no "today" marker.
 * Shares its query key with the attendance module, so it costs no extra request.
 */
export function useAttendanceStatus() {
  return tsr.attendance.getMyRealtimeStatus.useQuery({
    queryKey: ['attendance', 'realtime-status'],
  });
}

export function useToday(): string | undefined {
  return useAttendanceStatus().data?.body.date;
}

/** `2026-09-21` -> a UTC-noon Date, so formatting it with `timeZone: 'UTC'` never rolls the day. */
export function dateOnlyToDate(dateOnly: string): Date {
  return new Date(`${dateOnly}T12:00:00Z`);
}

export function formatDateOnlyShort(dateOnly: string, options: Intl.DateTimeFormatOptions): string {
  return dateOnlyToDate(dateOnly).toLocaleDateString('en-GB', { timeZone: 'UTC', ...options });
}
